import { useContextAndErrorIfNull } from '@listening/utils/react-helpers';
import { Dialog } from '@listening/frontend/components/radix/dialog';
import React, { createContext } from 'react';
import { PremiumDialog } from '@/components/web-fe/dialogs/premium-dialog';

export type PremiumGate =
  | 'playback_speed'
  | 'voice'
  | 'upload_limit'
  | 'file_type'
  | 'private_documents';

export const PremiumDialogContext = createContext<{
  currentPremiumDialog: PremiumGate | null;
  setCurrentPremiumDialog: (dialog: PremiumGate | null) => void;
} | null>(null);

export function PremiumDialogsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currentPremiumDialog, setCurrentPremiumDialog] =
    React.useState<PremiumGate | null>(null);

  return (
    <PremiumDialogContext
      value={{
        currentPremiumDialog,
        setCurrentPremiumDialog,
      }}
    >
      <Dialog
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            setCurrentPremiumDialog(null);
          }
        }}
        open={currentPremiumDialog !== null}
      >
        {children}
        {currentPremiumDialog && <PremiumDialog gate={currentPremiumDialog} />}
      </Dialog>
    </PremiumDialogContext>
  );
}
export function usePremiumDialog() {
  const context = useContextAndErrorIfNull(PremiumDialogContext);
  return context;
}
